import * as yup from "yup";

const LocationSchema = yup.object().shape({
  name: yup.string().max(40, 'The field cant have more than 40 characters').required(),
  street: yup.string().max(40, 'The field cant have more than 40 characters').required(),
  city: yup.string().required(),
  zip_code: yup.string().required(),
});

export default LocationSchema;
